import {
  date
} from 'quasar'
import moment from 'moment'
import ServiceGlobal from './../InputsServiceGlobal.js'
import ValidateGlobal from './../ValidateGlobal.js'
import NumberUtilsLib from 'utils/NumberUtils'
import Label from './../Label'
import {
  firebase
} from '@firebase/app'
const {
  Timestamp
} = firebase.firestore

export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      default: () => {
        return []
      },
      type: [Array, Object]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: [Array, Object]
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data() {
    return {
      value: this.config.syncModel ? this.modelProps : (this.modelProps ? this._.cloneDeep(this.modelProps) : []),
      rawData: {},
      dialogEdit: false,
      confirm: false,
      dataRowToDialog: {},
      dataRowOrigin: {},
      isProcessData: false,
      isAdding: false,
      selectedRowIndex: -1,
      isFirstLoad: true,
      valid: false,
      formInternalKey: 1,
      pagesNumber: 0,
      columns: this.config.columns,
      NumberUtils: NumberUtilsLib,
      moment: moment,
      R: this.R,
      bottomRowModel: this.config.bottomRow ? {} : null
    }
  },
  created() {
    if (this.isFirstLoad) {
      this.$emit('input', this.modelProps)
      this.isFirstLoad = false
    }
    this.init()
  },
  mounted() {
    if (this.config.sortBy) {
      this.$refs[this._uid].sort(this.config.sortBy)
    }
    this.pagesNumber = this.$refs[this._uid] ? this.$refs[this._uid].pagesNumber : Infinity
  },
  updated() {
    this.pagesNumber = this.$refs[this._uid] ? this.$refs[this._uid].pagesNumber : Infinity
  },
  methods: {
    init() {
      this.value = this.convertDataForShowing(this._.cloneDeep(this.modelProps), this.value)
      this.rawData = this._.cloneDeep(this.value)
      this.addColumnNoNActions()
      this.processData()
    },
    addColumnNoNActions() {
      if (this.config.indexColumn &&
        !this.columns.find(item => item.name === 'no') &&
        !this.$q.screen.xs) {
        this.columns.unshift({
          label: 'No',
          align: 'left',
          name: 'no',
          field: row => row.__index + 1
        })
      }
      if (this.config.editable &&
        !this.columns.find(item => item.name === 'actions')) {
        this.columns.push({
          align: 'right',
          name: 'actions'
        })
      }
      this.columns = this.columns.filter(item => !item.hasOwnProperty('showInTable') || (item.hasOwnProperty('showInTable') && item.showInTable === true))
    },
    processData() {
      // Process convert timestamp to normal date
      this.isProcessData = true
      let colDateType = this.columns
        .filter(item => item.type === 'DatePicker')
        .map(item => item.field)
      let colNumberType = this.columns
        .filter(item => item.type === 'NumberField')
        .map(item => item.field)
      this.value.forEach((element, index) => {
        colDateType.forEach(key => {
          try {
            element[key] = date.formatDate(element[key].toDate(), this.$store.state.config.defaultDateFormat)
          } catch (error) {
            console.log(error)
          }
        })
        colNumberType.forEach(key => {
          try {
            element[key] = this.NumberUtils.thousandSeprator(element[key])
          } catch (error) {
            console.log(error)
          }
        })
        element.__index = index
      })
      this.isProcessData = false
    },
    addItem() {
      this.isAdding = true
      this.dataRowToDialog = {}
      this.dialogEdit = true
    },
    resetData() {
      this.dialogEdit = false
      this.dataRowToDialog = {}
      this.selectedRowIndex = -1
      this.valid = true
      this.isAdding = false
    },
    submitDialogRowData() {
      let vm = this
      this.$refs[`datatable-${this._uid}`].validate().then(result => {
        if (result) {
          if (vm.isAdding) {
            // Add
            try {
              if (vm.config.dataType === 'MultiArray') {
                // eslint-disable-next-line no-eval
                let groupBy = eval('vm.dataRowToDialog.' + this.config.groupBy)
                if (!vm.modelProps.hasOwnProperty(groupBy)) {
                  vm.modelProps[groupBy] = []
                }
                vm.handleAddSubmit(vm.modelProps[groupBy])
              } else {
                vm.handleAddSubmit(vm.modelProps)
              }
              vm.isAdding = false
              vm.processData()
              vm.resetData()
            } catch (error) {
              console.log(error)
              this.valid = false
            }
          } else {
            // edit
            try {
              if (this.config.dataType === 'MultiArray') {
                // Multi array mode
                this._.merge(this.value[this.selectedRowIndex], this._.cloneDeep(this.dataRowToDialog))
                this._.merge(this.findDataInModel(this.modelProps, this.rawData[this.selectedRowIndex]), this.dataRowToDialog)
                this._.merge(this.rawData[this.selectedRowIndex], this._.cloneDeep(this.dataRowToDialog))
                this.resetNotShowingValues(this.dataRowToDialog, this.rawData[this.selectedRowIndex])
              } else {
                this._.merge(this.value[this.selectedRowIndex], this._.cloneDeep(this.dataRowToDialog))
                this._.merge(this.rawData[this.selectedRowIndex], this._.cloneDeep(this.dataRowToDialog))
                this._.merge(this.modelProps[this.selectedRowIndex], this.dataRowToDialog)
                this.resetNotShowingValues(this.dataRowToDialog, this.modelProps[this.selectedRowIndex])
              }
              this.processData()
              this.resetData()
            } catch (error) {
              console.log(error)
              this.valid = false
            }
          }
        } else {
          this.valid = false
        }
      })
    },
    resetNotShowingValues(dialogModel, rawModel) {
      for (let item in this.newScafolding.items) {
        if (this.newScafolding.items[item].show === false) {
          let fieldName = this.newScafolding.items[item].fieldName
          if (!this._.isEqual(dialogModel, rawModel) && dialogModel.hasOwnProperty(fieldName)) dialogModel[fieldName] = null
        }
      }
    },
    handleAddSubmit(model) {
      let vm = this
      if (vm.config.addType === 'first') {
        model.unshift(this.dataRowToDialog)
        vm.rawData.unshift(vm._.cloneDeep(vm.dataRowToDialog))
        vm.value.unshift(vm._.cloneDeep(vm.dataRowToDialog))
      } else {
        model.push(vm.dataRowToDialog)
        vm.rawData.push(vm._.cloneDeep(vm.dataRowToDialog))
        vm.value.push(vm._.cloneDeep(vm.dataRowToDialog))
      }
    },
    deleteItem() {
      let vm = this
      if (vm.config.fakeDelete) {
        vm.rawData[vm.selectedRowIndex]['@deleted'] = true
        vm.value[vm.selectedRowIndex]['@deleted'] = true
        vm.modelProps[vm.selectedRowIndex]['@deleted'] = true
      } else {
        if (vm.config.dataType === 'MultiArray') {
          let clonedDataFind = this._.omit(this._.cloneDeep(vm.rawData[vm.selectedRowIndex]), '__index')
          for (let key in vm.modelProps) {
            let finded = vm._.find(vm.modelProps[key], clonedDataFind)
            if (finded) {
              vm._.remove(vm.modelProps[key], finded)
            }
          }
          vm.rawData.splice(vm.selectedRowIndex, 1)
          vm.value.splice(vm.selectedRowIndex, 1)
        } else {
          vm.rawData.splice(vm.selectedRowIndex, 1)
          vm.value.splice(vm.selectedRowIndex, 1)
          vm.modelProps.splice(vm.selectedRowIndex, 1)
        }
      }
      this.dialogEdit = false
    },
    convertDataForShowing(model, defaultValue) {
      let resultModel = []
      if (this.config.dataType === 'MultiArray') {
        for (let index in model) {
          let attr = model[index]
          resultModel.unshift(...attr)
        }
        return resultModel
      }
      return model ? model : defaultValue
    },
    customSort(rows, sortBy, descending, a) {
      let rowsCopy = rows
      let vm = this
      let cols = vm.columns
      let found = vm._.find(cols, item => item.name === sortBy)
      let sortResult
      if (found.sort) {
        sortResult = rowsCopy.sort(found.sort)
        sortResult = descending ? sortResult.reverse() : sortResult
      } else {
        sortResult = rowsCopy.sort((a, b) => {
          let x = descending ? b[sortBy] : a[sortBy]
          let y = descending ? a[sortBy] : b[sortBy]
          if (found && found.type === 'DatePicker') {
            return (moment(x, vm.$store.state.config.defaultDateFormat) > moment(y, vm.$store.state.config.defaultDateFormat) ? 1 : moment(x, vm.$store.state.config.defaultDateFormat) < moment(y, vm.$store.state.config.defaultDateFormat) ? -1 : 0)
          }
          if (typeof x === 'string' && typeof y === 'string') {
            return x.localeCompare(y)
          }
          return x > y ? 1 : x < y ? -1 : 0
        })
      }
      let position = 0
      sortResult.forEach((element) => {
        element.position = position
        if (!(this.config.fakeDelete && element['@deleted'] === true)) {
          position = position >= (vm.config.pagination.rowsPerPage ? vm.config.pagination.rowsPerPage : sortResult.length) - 1 ? 0 : position + 1
        }
      })
      return sortResult
    },
    findDataInModel(model, dataFind) {
      let clonedDataFind = this._.omit(this._.cloneDeep(dataFind), '__index')
      for (let key in model) {
        let finded = this._.find(model[key], clonedDataFind)
        if (finded) {
          return finded
        }
      }
      return undefined
    },
    clickEditButton(props) {
      var vm = this
      vm.dialogEdit = true
      vm.selectedRowIndex = props.row.__index
      if (vm.config.dataType === 'MultiArray') {
        let dataFinded = vm.findDataInModel(vm.modelProps, vm.rawData[vm.selectedRowIndex])
        vm.dataRowToDialog = vm._.cloneDeep(dataFinded)
        let dataFindedOrigin = vm.findDataInModel(vm.originModel, vm.rawData[vm.selectedRowIndex])
        vm.dataRowOrigin = dataFindedOrigin
      } else {
        vm.dataRowToDialog = vm._.cloneDeep(vm.modelProps[vm.selectedRowIndex])
        vm.dataRowOrigin = vm.originModel ? vm._.cloneDeep(vm.originModel[vm.selectedRowIndex]) : {}
      }
    },
    valueChangeOutTable(rowsValue, value) {
      if (this.config.changeValueOutTable) {
        this.modelProps = this._.merge(this.modelProps, this.value)
      }
    },
    selfCommand() {
      this.$emit('command', {
        cmd: 'submit-data'
      })
    },
    // eslint-disable-next-line no-unused-vars
    formatString(string, props) {
      // eslint-disable-next-line no-eval
      return eval(string)
    }
  },
  computed: {
    newScafolding() {
      let newScafolding = {
        items: {}
      }
      let vm = this
      this.config.columns.forEach((ele, index) => {
        let newEle = vm._.cloneDeep(ele)
        if (newEle.name === 'no' || newEle.name === 'actions') {
          return
        }
        if (!newEle.hasOwnProperty('fieldName')) {
          newEle['fieldName'] = newEle.field
        }
        newScafolding.items[`item-${index + 1}`] = newEle
      })
      return newScafolding
    },
    isMobileView() {
      return this.$q.screen.xs
    }
  },
  watch: {
    'dataRowToDialog': {
      handler: function (value) {
        let vm = this
        if (vm.isAdding && vm.config.hasOwnProperty('duplicateRules') && !vm._.isEmpty(value)) {
          let finded = vm.config.duplicateRules.hasOwnProperty('isMatch') && vm.config.duplicateRules.isMatch ? vm._.findIndex(vm.rawData, item => vm._.isMatch(value[vm.config.duplicateRules.uniqueField], item[vm.config.duplicateRules.uniqueField])) : vm._.findIndex(vm.rawData, item => vm._.isEqual(item[vm.config.duplicateRules.uniqueField], value[vm.config.duplicateRules.uniqueField]))
          if (finded !== -1) {
            vm.selectedRowIndex = finded
            vm.isAdding = false
            if (vm.config.dataType === 'MultiArray') {
              let dataFinded = vm.findDataInModel(vm.modelProps, vm.rawData[finded])
              vm.dataRowToDialog = vm._.cloneDeep(dataFinded)
              vm.formInternalKey++
            } else {
              vm.dataRowToDialog = vm._.cloneDeep(vm.modelProps[finded])
              vm.formInternalKey++
            }
          }
        }
      },
      deep: true
    },
    'config.pagination': {
      handler: function (newVal, oldVal) {
        if (newVal.page === oldVal.page && newVal.rowsPerPage === oldVal.rowsPerPage) return
        if (this.config.lazyLoad && (newVal.page === this.pagesNumber)) {
          this.$emit('command', {
            cmd: 'fetch-data'
          })
        }
      },
      deep: true
    },
    modelProps: {
      handler: function () {
        if (this.config.syncModel) {
          this.value = this._.cloneDeep(this.modelProps)
        }
        this.init()
      },
      deep: true
    },
    // value: {
    //   handler: function(newValue, oldValue) {
    //     console.log('new',JSON.parse(JSON.stringify(newValue)))
    //     console.log('old',JSON.parse(JSON.stringify(oldValue)))
    //     console.log(this.emitInputTable)
    //     if(this.config.syncModel && this.emitInputTable) {
    //       this.$emit('inputTable', { oldValue, newValue, config: this.config })
    //     }
    //   },
    //   deep: true
    // }
  },
  components: {
    Label
  }
}